export default __webpack_public_path__ + "static/media/logo-autosender.9da80857.png";